export const strategyQueryKeys = {
  userStrategies: ["user-strategies"],
  strategies: ["strategies"],
  strategyStatus: ["strategyStatus"],
};
